import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const copyToNext: ISVGPersonalProps = {
  viewBox: '0 0 24 24',
  content: (
    <g id="copy_to_next_icon" data-name="copy to next icon" transform="translate(1336 -7776)" overflow="visible">
      <rect
        id="Rectangle_3000"
        data-name="Rectangle 3000"
        width="24"
        height="24"
        transform="translate(-1336 7776)"
        fill="none"
        overflow="visible"
      />
      <g id="Group_4125" data-name="Group 4125" transform="translate(-1333.597 7778.549)" overflow="visible">
        <g id="Group_4124" data-name="Group 4124" overflow="visible">
          <path
            overflow="visible"
            id="Path_7153"
            data-name="Path 7153"
            d="M0,2.313V9.252a1.606,1.606,0,0,0,1.542,1.542H7.325A1.606,1.606,0,0,0,8.867,9.252V3.093L6.168,0H1.542A1.606,1.606,0,0,0,0,1.542ZM8.1,9.252a.808.808,0,0,1-.771.771H1.542a.808.808,0,0,1-.771-.771V1.542A.808.808,0,0,1,1.542.771H5.4c-.006.888,0,1.552,0,1.552A1.588,1.588,0,0,0,6.939,3.855H8.1ZM6.939,3.084c-.411,0-.771-.746-.771-1.146V.783h0L8.1,3.084ZM6.168,5.4H2.7a.385.385,0,1,0,0,.77h3.47a.385.385,0,1,0,0-.77m0,1.926H2.7a.385.385,0,1,0,0,.77h3.47a.385.385,0,1,0,0-.77"
            transform="translate(0)"
            fill="#79cdd0"
            stroke="#79cdd0"
            strokeWidth="0.2"
          />
          <path
            overflow="visible"
            id="Path_7154"
            data-name="Path 7154"
            d="M343.048,271.613v6.939a1.606,1.606,0,0,0,1.542,1.542h5.783a1.606,1.606,0,0,0,1.542-1.542v-6.159l-2.7-3.093H344.59a1.606,1.606,0,0,0-1.542,1.542Zm8.1,6.939a.808.808,0,0,1-.771.771H344.59a.808.808,0,0,1-.771-.771v-7.71a.808.808,0,0,1,.771-.771h3.855c-.006.888,0,1.552,0,1.552a1.588,1.588,0,0,0,1.542,1.532h1.157Zm-1.157-6.168c-.411,0-.771-.746-.771-1.146v-1.155h0l1.928,2.3Zm-.771,2.32h-3.47a.385.385,0,1,0,0,.77h3.47a.385.385,0,1,0,0-.77m0,1.926h-3.47a.385.385,0,1,0,0,.77h3.47a.385.385,0,1,0,0-.77"
            transform="translate(-332.721 -261.193)"
            fill="#79cdd0"
            stroke="#79cdd0"
            strokeWidth="0.2"
          />
          <path
            overflow="visible"
            id="Path_7155"
            data-name="Path 7155"
            d="M328.708,108.259a.376.376,0,0,1-.376-.376v-2.965h-3.073a.376.376,0,1,1,0-.753h3.449a.376.376,0,0,1,.376.376v3.341a.376.376,0,0,1-.376.376"
            transform="translate(-315.103 -101.029)"
            fill="#79cdd0"
            stroke="#79cdd0"
            strokeWidth="0.2"
          />
          <path
            overflow="visible"
            id="Path_7156"
            data-name="Path 7156"
            d="M393.5,176.5a.375.375,0,0,1-.266-.11l-1.438-1.438a.376.376,0,1,1,.532-.532l1.172,1.172,1.172-1.172a.376.376,0,0,1,.532.532l-1.438,1.438a.375.375,0,0,1-.266.11"
            transform="translate(-379.891 -169.061)"
            fill="#79cdd0"
            stroke="#79cdd0"
            strokeWidth="0.2"
          />
        </g>
      </g>
    </g>
  ),
};
